import ObservationEditForm from "@/components/observations/ObservationEditForm";
import { useParams } from "react-router";

const ObservationEditPage: React.FC = () => {
  const params = useParams();

  return (
    <div className="container mx-auto p-4">
      <ObservationEditForm
        observationId={params.observationId!}
        onCancel={() => console.log("Cancel")}
        showFooter={true}
        attachmentColumn={false}
      />
    </div>
  );
};

export default ObservationEditPage;
